// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"ds","backToTop":"ds"};